import React, { Component } from "react";
import styles from "./PreLoader.module.css";

function PreLoader({ children }) {
  return (
    <>
      <div className={`${styles.PreLoaderCont} `}>
        <div className={`${styles.PreLoader} `}>
          {children}
          <div className={`${styles.PreLoaderDots} `}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </>
  );
}

export default PreLoader;
